/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { JumboStructsFindingApps } from './JumboStructsFindingApps';
import {
    JumboStructsFindingAppsFromJSON,
    JumboStructsFindingAppsFromJSONTyped,
    JumboStructsFindingAppsToJSON,
} from './JumboStructsFindingApps';

/**
 * 
 * @export
 * @interface JumboStructsAppListFinding
 */
export interface JumboStructsAppListFinding {
    /**
     * 
     * @type {Array<JumboStructsFindingApps>}
     * @memberof JumboStructsAppListFinding
     */
    items?: Array<JumboStructsFindingApps>;
    /**
     * 
     * @type {number}
     * @memberof JumboStructsAppListFinding
     */
    total?: number;
}

/**
 * Check if a given object implements the JumboStructsAppListFinding interface.
 */
export function instanceOfJumboStructsAppListFinding(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function JumboStructsAppListFindingFromJSON(json: any): JumboStructsAppListFinding {
    return JumboStructsAppListFindingFromJSONTyped(json, false);
}

export function JumboStructsAppListFindingFromJSONTyped(json: any, ignoreDiscriminator: boolean): JumboStructsAppListFinding {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': !exists(json, 'items') ? undefined : ((json['items'] as Array<any>).map(JumboStructsFindingAppsFromJSON)),
        'total': !exists(json, 'total') ? undefined : json['total'],
    };
}

export function JumboStructsAppListFindingToJSON(value?: JumboStructsAppListFinding | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': value.items === undefined ? undefined : ((value.items as Array<any>).map(JumboStructsFindingAppsToJSON)),
        'total': value.total,
    };
}

